import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <rect x='10.5' width='4.36364' height='4.36364' rx='2.18182' />
            <rect x='10.5' y='6.54541' width='4.36364' height='17.4545' rx='2.18182' />
        </SvgIcon>
    );
});
